import { combineEpics } from "redux-observable"
import {
    deleteEpic,
    fetchEpic,
    submitEpic
} from "./epics"

export const combinedEpics = combineEpics(
    fetchEpic,
    submitEpic,
    deleteEpic
)
export const InventoryLocationEpics = combinedEpics


// WEBPACK FOOTER //
// ./src/state/inventory/location/epics/index.ts